import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "v-btn__content" }
const _hoisted_2 = { class: "ms-5 mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-sm-body-2 text-red mb-2"
}

import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import ReviewForm from '../../../api/v2/forms/review'
import Simplemde from '../atoms_molecules/Simplemde.vue'
import { userState } from '../../stores/user'
import { headerState } from '../../stores/header'
import { checkMobile } from '../../utils/utils'
import { reviewState } from '../../stores/reviews'
import { getQueryString } from '../../../../helpers/route-helper'


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewDialog',
  props: {
    courseId: { default: '' },
    enrollmentId: { default: '' }
  },
  emits: ["updateReview"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const route = useRoute()

const dialog = ref(false)
const title = ref('')
const body = ref('')
const hasReview = ref(false)
const invalidBody = ref(false)
const isNotConfirm = ref(true)
const confirmed = ref(false)
const mobile = checkMobile()
const rating = ref(0)

const user = computed(() => userState.user)
const schoolSetting = computed(() => headerState.schoolSetting)
const shouldShowReviewButton = computed(() => schoolSetting.value && schoolSetting.value.useEvaluateLesson)

const currentTime = computed(() => {
  var today = new Date()
  return `${today.getFullYear()}-${(today.getMonth()+1)}-${today.getDate()}`
})

const reviewQuery = computed(() => getQueryString(route.query, 'review'))

const backToForm = () => {
  isNotConfirm.value = true
  confirmed.value = false
}

const createReview = async () => {
  invalidBody.value = !body.value
  if (invalidBody.value) return

  const reviewForm = new ReviewForm()
  if (props.courseId) {
    reviewForm.courseId = props.courseId
  }
  if (props.enrollmentId) {
    reviewForm.enrollmentId = props.enrollmentId
  }
  isNotConfirm.value = false
  reviewForm.rank = rating.value
  reviewForm.body = body.value

  await reviewState.create(reviewForm)
  emit('updateReview')
  setTimeout(() => {
    isNotConfirm.value = true
    dialog.value = false
  }, 3000)
}

onMounted(() => {
  if (reviewQuery.value) {
    dialog.value = true
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_rating = _resolveComponent("v-rating")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (shouldShowReviewButton.value)
    ? (_openBlock(), _createBlock(_component_v_dialog, {
        key: 0,
        modelValue: dialog.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialog).value = $event)),
        "max-width": "590"
      }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_btn, _mergeProps({ class: "v-btn v-btn--contained theme--dark" }, props, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => {hasReview.value = false;})
          }), {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, [
                _createVNode(_component_v_icon, { class: "me-1" }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("mdi-star", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _cache[7] || (_cache[7] = _createTextVNode("評価する ", -1 /* CACHED */))
              ])
            ]),
            _: 1 /* STABLE */
          }, 16 /* FULL_PROPS */)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_card, {
            class: "user-question-dialog pb-4",
            style: {"text-align":"center"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, {
                class: "headline",
                style: {"padding-left":"13%"}
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("この評価の理由をおお聞かせてください", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }),
              (isNotConfirm.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_v_rating, {
                        modelValue: rating.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((rating).value = $event)),
                        color: "yellow accent-4",
                        density: "compact",
                        hover: "",
                        size: "32"
                      }, null, 8 /* PROPS */, ["modelValue"])
                    ]),
                    (!hasReview.value)
                      ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                          default: _withCtx(() => [
                            (invalidBody.value)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_3, "内容を入力してください"))
                              : _createCommentVNode("v-if", true),
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((body).value = $event)),
                              placeholder: "レビュー内容を入力してください",
                              rows: "5",
                              class: "review-body"
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, body.value]
                            ]),
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "d-flex" }, null, -1 /* CACHED */))
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "green",
                          onClick: createReview
                        }, {
                          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                            _createTextVNode(" レビューする ", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }),
                        _createVNode(_component_v_btn, {
                          color: "green-darken-1",
                          text: "",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (dialog.value = false))
                        }, {
                          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                            _createTextVNode("キャンセル ", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createElementVNode("h2", { class: "mt-3 ms-10" }, " ありがとうございます。", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "green-darken-1",
                          text: "",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (dialog.value = false))
                        }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createTextVNode("閉じる ", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ], 64 /* STABLE_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"]))
    : _createCommentVNode("v-if", true)
}
}

})